module.exports = __webpack_public_path__ + "files/46b2e5f7ae215193538127219e180bf9.png";